/**
 * @file 国际化
 */
import { intl } from 'di18n-vue';
import zhCN from '@/assets/i18n/zh';
import enUS from '@/assets/i18n/en';

const locales = {
    'zh-CN': zhCN,
    'en-US': enUS,
}
function getLang() {
    const reg = /Accept-Language\/([^;\s]+)/i;
    const _ua = window.navigator.userAgent.toLowerCase();
    const langMatch = _ua.match(reg);
    let lang = langMatch && langMatch[1].trim()
        // || navigator.language || navigator.userLanguage
        || 'zh-CN';
    if (lang.toLowerCase() === 'zh-cn') {
        lang = 'zh-CN';
    } else {
        lang = 'en-US';
    }
    return lang;
}
export const lang = getLang();
const locale = locales[lang];
const week = ['日', '一', '二', '三', '四', '五', '六'];
const exclude = new Set([...week]);
export const transObj = {
    $t(template, data) {
        const result = locale[template];
        if (!result) {
            return template;
        }
        return result.replace(/\{([\w.]+)\}/g, (match, path) => {
            return path.split('.').reduce((obj, key) => {
                return (obj && obj[key] !== undefined)
                    ? obj[key]
                    : match;
            }, data);
        });
    },
    t(key, ...rest) {
        if (exclude.has(key)) {
            return key;
        }
        return intl.$t(key, ...rest);
    },
}


// WEBPACK FOOTER //
// ./src/utils/translate.js